import { field, getDecodedEvent, readContract, writeContractAndWait } from "../viem";
import config from "../../config/config";
import MafiaRaceLobbyAbi from "../../abis/MafiaRaceLobby.json";
import { toWei } from "../../utils/utils";
import type { RaceFinishReceipt } from "../../types/Racing/RaceFinishReceipt";

const address = config.raceLobby;
const abi = MafiaRaceLobbyAbi;

export const createRace = async (
  carId: number,
  cashAmount: number,
  prizeType: number,
  signature: string,
  signMsg: string,
  account: string
) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "createRace",
    args: [
      carId,
      toWei(cashAmount),
      prizeType,
      JSON.stringify(signMsg),
      signature,
    ],
    account,
  });

  return tx.transactionHash;
};

export const joinRace = async (
  raceId: number,
  carId: number,
  signature: string,
  signMsg: string,
  account: string
) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "joinRace",
    args: [raceId, carId, JSON.stringify(signMsg), signature],
    account,
  });

  const finished = getDecodedEvent(tx, abi, "RaceFinished")?.returnValues;
  const loggedRaceId = Number(field<string>(finished, "raceId", 0));
  const finishedRaceId = Number.isSafeInteger(loggedRaceId) && loggedRaceId >= 0
    ? loggedRaceId : raceId;
  const finish: RaceFinishReceipt | null = finished ? {
    raceId: finishedRaceId,
    winner: field<string>(finished, "winner", 1),
    result: Number(field<string>(finished, "result", 2)),
    winnerCashProfit: Number(field<string>(finished, "winnerCashProfit", 5)),
    creatorHealthLost: Number(field<string>(finished, "creatorHealthLost", 8)),
    opponentHealthLost: Number(field<string>(finished, "opponentHealthLost", 9)),
  } : null;

  return {
    transactionHash: tx.transactionHash,
    raceId: finishedRaceId,
    finish,
  };
};

export const cancelRace = async (raceId: number, account: string) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "cancelRace",
    args: [raceId],
    account,
  });

  return tx.transactionHash;
};

export const getHasActiveLobby = async (account: string) => {
  const hasActive = await readContract({
    address,
    abi,
    functionName: "hasActiveLobby",
    args: [account],
  });

  return hasActive;
};

export const getNextRaceTime = async (account: string) => {
  const nextRaceTime = await readContract<string>({
    address,
    abi,
    functionName: "nextRaceTime",
    args: [account],
  });

  return Number(nextRaceTime);
};
